import React, { useRef, useState } from 'react';

import styles from './_edit-cell.module.scss';

type EditCellProps = {
  selectedID: number | null;
  selectedName: string;
  element: EditableElement;
  onSubmit: (element: EditableElement) => void;
  width?: number;
  wrapperTag?: 'div' | 'td';
};

type EditableElement = { id: number; name: string };

const EditCell: React.FC<EditCellProps> = ({
  selectedID,
  element,
  selectedName,
  onSubmit,
  width = 20,
  wrapperTag = 'td',
}) => {
  const editableCellInputRef = useRef<HTMLInputElement>(null);

  const [editableElement, setEditableElement] = useState<EditableElement | null>(null);

  const onEditCellClick = () => {
    if (selectedID !== element.id) return;

    setEditableElement({ name: element.name, id: element.id });
  };

  const updateProjectName = () => {
    if (editableElement?.name?.trim().length && editableElement.name !== selectedName) onSubmit(editableElement);

    setEditableElement(null);
  };

  const innerInput = () => (
    <>
      {editableElement?.id === element.id ? (
        <input
          ref={editableCellInputRef}
          autoFocus
          onFocus={() => setTimeout(() => editableCellInputRef?.current?.select(), 10)}
          onKeyDown={(e) => e.key === 'Enter' && updateProjectName()}
          onBlur={updateProjectName}
          value={editableElement.name}
          onChange={(e) => setEditableElement((prev) => prev && { ...prev, name: e.target?.value })}
          style={{ height: '24px', width: '100%' }}
        />
      ) : (
        element.name
      )}
    </>
  );

  return (
    <>
      {wrapperTag === 'td' ? (
        <td onClick={onEditCellClick} style={{ width: `${width}%` }} className={styles.td}>
          {innerInput()}
        </td>
      ) : (
        <div onClick={onEditCellClick} style={{ width: `${width}%` }} className={styles.div}>
          {innerInput()}
        </div>
      )}
    </>
  );
};

export { EditCell };
